import { SLOTS } from 'types';
import { preciseAddSubtract } from 'utils/roundToFix';
import { BetType } from '../types';
import { EMPTY_BET } from '../data';

export const getSummaryBet = (bets: BetType[]): BetType =>
  Object.values(bets).reduce(
    (summaryBet, bet) => ({
      [SLOTS.player]: preciseAddSubtract(summaryBet[SLOTS.player], bet[SLOTS.player], 'add'),
      [SLOTS.tie]: preciseAddSubtract(summaryBet[SLOTS.tie], bet[SLOTS.tie], 'add'),
      [SLOTS.banker]: preciseAddSubtract(summaryBet[SLOTS.banker], bet[SLOTS.banker], 'add'),
      [SLOTS.perfectPair]: preciseAddSubtract(
        summaryBet[SLOTS.perfectPair],
        bet[SLOTS.perfectPair],
        'add',
      ),
      [SLOTS.anyPair]: preciseAddSubtract(summaryBet[SLOTS.anyPair], bet[SLOTS.anyPair], 'add'),
      [SLOTS.playerPair]: preciseAddSubtract(
        summaryBet[SLOTS.playerPair],
        bet[SLOTS.playerPair],
        'add',
      ),
      [SLOTS.bankerPair]: preciseAddSubtract(
        summaryBet[SLOTS.bankerPair],
        bet[SLOTS.bankerPair],
        'add',
      ),
      [SLOTS.playerBonus]: preciseAddSubtract(
        summaryBet[SLOTS.playerBonus],
        bet[SLOTS.playerBonus],
        'add',
      ),
      [SLOTS.bankerBonus]: preciseAddSubtract(
        summaryBet[SLOTS.bankerBonus],
        bet[SLOTS.bankerBonus],
        'add',
      ),
      [SLOTS.luckySeven]: preciseAddSubtract(
        summaryBet[SLOTS.luckySeven],
        bet[SLOTS.luckySeven],
        'add',
      ),
      [SLOTS.luckySix]: preciseAddSubtract(summaryBet[SLOTS.luckySix], bet[SLOTS.luckySix], 'add'),
    }),
    {
      ...EMPTY_BET,
    },
  );
